import {Component, Input} from '@angular/core';


@Component({
    selector: 'ui-input-errors',
    template: `
	    <div class="ui-input-errors help-block" *ngIf="errors">
		    <span *ngFor="let kv of errors|kv">
                    <span class="label alert-danger"> {{kv.value}} </span>
                    &nbsp;
		        </span>
	    </div>
    `
})
export class UIInputErrorsComponent {
    @Input() errors;

}
